import React, {Component} from 'react';
import {Card, Grid, Header} from 'semantic-ui-react';
import DunsLookupCard from 'go/pages/home/DunsLookupCard';
import PanelReviewCardV2 from 'go/components/panelReview2/panelReviewCard';
import RecipientActions from 'go/pages/home/RecipientActions';
import _ from 'lodash';
import {HOME_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {Toggle} from 'componentLibrary';
import {canViewGrantsTab} from 'go/security/permissions';
import {retrieveEntityTypeIdsFromPermissions} from 'common/utils';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';

const bodyTitle = "Welcome to FEMA's new grant system!";
const bodyCopyTop = `FEMA Grants Outcomes (GO) supports the Preparedness: Fire & Life Safety and Mitigation: Hazards categories of grant programs.  As the application is developed, more functionality and grant programs will be available for your use.`;
const bodyCopyTopIA = `FEMA Grants Outcomes (GO) supports the Preparedness: Fire & Life Safety, Mitigation: Hazards and Recovery: Assistance to Individuals categories of grant programs. As the application is developed, more functionality and grant programs will be available for your use.`;

const bodyCopyBottom = ``;


export default class NonFemaLandingPage extends Component {
  componentDidMount() {
    document.title = HOME_PAGE;
  }

  hasNonPanelRole = (entityTypeIds) => {
    let result = false

    _.forEach(entityTypeIds, (entityType)=>{
      if(entityType !== ENTITY_MAP.PANEL_REVIEW.code){
        result = true;
      }
    });

    return result;
  }

  render() {
    const {enterBy, displayName, permissions, jwt, toggles} = this.props;
    //this page is loading before toggles is loaded
    const panelReviewV2Toggle = _.includes(toggles, 'panelReviewV2');
    const femaIAApplicationToggle = _.includes(toggles, 'femaIAApplication');
    const appDevAndSubToggle = _.includes(toggles, 'appDevAndSub1-1');

    const entityTypeIds = retrieveEntityTypeIdsFromPermissions(permissions);

    if(appDevAndSubToggle){
      return (
        <React.Fragment>
          <Grid stackable>
            {enterBy !== "FEMA APS" && (
              <>
              <Grid.Row className='homepage-row-spacing'>
                <Grid.Column style={{paddingLeft:0}}>
                <Toggle toggle="panelReviewV2">
                  <PanelReviewCardV2
                    jwt={jwt}
                    permissions={permissions}
                    toggles={toggles}
                  />
                </Toggle>
                </Grid.Column>
                </Grid.Row>
                <Grid.Row className='homepage-row-spacing'>
                {!_.isEmpty(permissions) && canViewGrantsTab(permissions) && (
                  <RecipientActions
                    token={jwt}
                    permissions={permissions}
                    enterBy={enterBy}
                  />
                )}
                </Grid.Row>
                {!this.hasNonPanelRole(entityTypeIds) && 
                (
                  <Grid className="duns-card">
                    <Grid.Row>
                      <h3>Search for your organization</h3>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <DunsLookupCard />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {displayName && <Header as="h1"> Hello, {displayName}!</Header>}
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={12}>
                <Card fluid>
                  <Card.Content className="leadParagraph">
                    <Header as="h3"> {bodyTitle}</Header>
                    <p>{femaIAApplicationToggle ? bodyCopyTopIA : bodyCopyTop}</p>
                    <p>{bodyCopyBottom}</p>
                  </Card.Content>
                </Card>
              </Grid.Column>
            </Grid.Row>
            {!_.isEmpty(permissions) && canViewGrantsTab(permissions) && (
              <RecipientActions token={jwt} permissions={permissions} enterBy={enterBy} />
            )}
            {enterBy !== 'FEMA APS' && (
              <Grid.Row columns={2}>
                <Toggle toggle="panelReviewV2">
                  <PanelReviewCardV2 jwt={jwt} permissions={permissions} />
                </Toggle>
                <Grid.Column width={6}>
                  <DunsLookupCard />
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>
        </React.Fragment>
      )
    }
  }
}
